<template>
  <div id="app">
    <header-menu></header-menu>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import HeaderMenu from '@/components/_HeaderMenu'

export default {
  name: 'App',
  components: {
    HeaderMenu
  }
}
</script>

<style lang="scss">
  @import 'src/assets/css/reset.scss';
  @import 'src/assets/css/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue